import { Injectable } from '@angular/core';

@Injectable()
export class LanguageService {

    /**
     * Get month name in Spanish
     * @param monthIndex Zero based index of month (0 - 11)
     */
    public getMonthInSpanish = (monthIndex: number) => {

        // validate inputs
        if (monthIndex < 0 || monthIndex > 11)
            throw new Error("Month index should be 0 - 11");

        // return month name
        switch (monthIndex) {
            case 0:
                return 'Enero';

            case 1:
                return "Febrero";

            case 2:
                return "Marzo";

            case 3:
                return "Abril";

            case 4:
                return "Mayo";

            case 5:
                return "Junio";

            case 6:
                return "Julio";

            case 7:
                return "Agosto";

            case 8:
                return "Septiembre";

            case 9:
                return "Octubre";

            case 10:
                return "Noviembre";

            case 11:
                return "Diciembre";
        }

    };

}